import { MsalProvider } from '@azure/msal-react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { PublicClientApplication, EventType } from '@azure/msal-browser';

import App from './app/app';
import { environment } from './environments/environment';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.NX_APP_AZURE_AD_CLIENT_ID,
    authority: environment.NX_APP_AZURE_AD_AUTHORITY,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
});

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    console.warn('AAD session expired – redirecting to login');
    msalInstance.loginRedirect();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </StrictMode>
);
